import { baseSelector } from '@app/core/store/_prototypes/action-reducers/selectors/base.selectors';
import { LoadState } from '@app/core/store/_prototypes/action-reducers/state/load.state';
import { createSelector } from '@ngrx/store';

const loading = <Key extends object, T>(state: (state: any) => LoadState<Key, T>) =>
  createSelector(state, (s) => s.loading);
const loaded = <Key extends object, T>(state: (state: any) => LoadState<Key, T>) =>
  createSelector(state, (s) => !!s.loaded);
const loadedData = <Key extends object, T>(state: (state: any) => LoadState<Key, T>) =>
  createSelector(state, (s) => s?.loaded);
const requested = <Key extends object, T>(state: (state: any) => LoadState<Key, T>) =>
  createSelector(state, (s) => !s.requested);

export const loadSelector = <Key extends object, T>(state: (state: any) => LoadState<Key, T>) => ({
  loading: loading(state),
  loaded: loaded(state),
  loadedData: loadedData(state),
  requested: requested(state),
  ...baseSelector(state),
});
